/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { DoctorUpdateRequest } from './doctorUpdateRequest';
import { GeneralProfileUpdateRequest } from './generalProfileUpdateRequest';
import { IndividualUpdateRequest } from './individualUpdateRequest';
import { MedStaffUpdateRequest } from './medStaffUpdateRequest';
import { OrganizationUpdateRequest } from './organizationUpdateRequest';
import { PatientUpdateRequest } from './patientUpdateRequest';
import { ResearcherUpdateRequest } from './researcherUpdateRequest';

export interface FullUserUpdateRequest { 
    profile?: GeneralProfileUpdateRequest;
    organization?: OrganizationUpdateRequest;
    individual?: IndividualUpdateRequest;
    patient?: PatientUpdateRequest;
    doctor?: DoctorUpdateRequest;
    med_staff?: MedStaffUpdateRequest;
    researcher?: ResearcherUpdateRequest;
}